<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
import { WebEmbedParticle } from "components/cards/particles/YinzCam";
export let container = undefined;
export let webEmbed = undefined;
</script>

<style></style>

<BaseAtom _isotope={"WebEmbed"} {...container}>
  <WebEmbedParticle _block={true} {...webEmbed} />
</BaseAtom>
